export default "__VITE_PUBLIC_ASSET__1e495372__"